export const CBRE_UUID5_NS = '653016f4-5a94-5545-bacd-1cca6b868215';
export const X_CBRE_HTTP_TRANSACTION_ID_HEADER = 'Transaction-Id';
export const X_CBRE_REQUEST_ID_HEADER = 'Request-Id';
